export default __webpack_public_path__ + "static/media/om.b9790bab.svg";